<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>部门设置&nbsp;&nbsp;说明:</h5>
				<span>1、使用后不能删除,但可以先注销停止使用</span><br>
				<span></span><br>
			</div>
		</div>

		<div class="content_edit">
			<pre-button @button-event="select_method" :pre_control="'control_user'" />
			<div class="content_btn">
				<div class="content_btn_item">
					<button @click="look_note">备注说明</button>
				</div>
			</div>
		</div>
		<div class="content_edit">
			<div class="content_edit_item">
				<label>名称：</label>
				<input type="text" v-model="s_name" />
			</div>
			<div class="content_edit_item">
				<label>跟踪表示：</label>
				<input type="text" v-model="s_note" />
			</div>
		</div>

		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr>
					<th style="display:none;">ID</th>
					<th>序号</th>
					<th class="left">名称</th>
					<th>标识</th>
					<th>状态</th>
					<!-- <th v-show="show_action">操作</th> -->
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr v-bind:id="'tr' + user.item.row_num" @click="sel_row(user.item)">
					<td style="display:none;">{{ user.item.id }}</td>
					<td>{{ user.item.row_num }}</td>
					<td class="left">{{ user.item.val }}</td>
					<td>{{ user.item.note }}</td>
					<td>{{ user.item.flag }}</td>
					<!-- <td v-show="show_action">
						<img src="../../assets/image/edit.png" @click="fun_upd(user.item)" />
						<img src="../../assets/image/delete.png" @click="fun_del(user.item.id)" />
					</td> -->
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">

			</template>
		</pre-table>


	</div>
</template>

<script>
	import api from '@/utils/type.js';

	import {
		Method_EasySelect,
		Method_EasyAdd,
		Method_EasyDelete,
		Method_EasyUpdate
	} from '@/utils/loadhttpdata.js';

	export default {
		components: {
			"pre-button": () => import("../per_old/pre_btn_control_easy.vue"),
			"pre-table": () => import("../per_old/pre_table_nokey.vue")
		},
		data() {
			return {
				load_url: '',
				load_json: '',
				upd_json: '',
				key_word: '',
				t_action_name: '',
				t_action: '',
				t_rowid: '',

				s_name: "",
				s_note: '',
				s_flag: '',

				show_action: true, //操作控制
				nowpage: '1',
				bak_data: '', //防止重复操作

			};
		},
		created: function() {
			this.fun_init();
			this.loaddata();
		},
		mounted: function() {
			// var that=this;
			// this.$nextTick(function() {

			// });
		},
		methods: {
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			loaddata: function() {
				this.load_url = api.http_method;
				this.load_json = Method_EasySelect('data_dep', '1', '', '');
			},
			select_method: function(type) {
				console.log(type);
				if (type != 'add' && type != 'sel' && Number(this.t_rowid) == 0) {
					this.$message.error('请先选择要编辑的数据!');
					return;
				}
				switch (type) {
					case 'new':
						this.data_clear();
						break;
					case 'add':
						// 不能在方法里传  this.变量
						this.fun_add();
						break;
					case 'upd':
						this.fun_upd();
						break;
					case 'del':
						this.fun_del();
						break;
					case 'sel':
						this.refresh_data();
						break;
					case 'sub':
						this.fun_sub();
						break;
					case 'exl':
						this.fun_exl();
						break;
					case 'fileup':
						this.fun_fileup();
						break;
					case 'filelook':
						this.fun_filelook();
						break;
					case 'filedel':
						this.fun_filedel();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			refresh_data: function(page, keyword, type) {
				// console.log('刷新结果page=' + page + ' keyword=' + keyword + ' type=' + type);
				let r = (Math.random() + '').substring(0, 4);
				// console.log('随机串='+r);
				this.load_json = Method_EasySelect('data_dep', '1', r);
			},
			fun_init: function() {
				// 这里放每次点击行  需要初始化的数据
				this.t_action_name = '保存';
				this.t_action = 'add';
			},
			fun_add: function() {
				// 展示新增位置
				if (this.s_name == null || String(this.s_name).length == 0 || String(this.s_name).length > 20) {

					this.$message({
						message: '操作不正确,当前名称不能为空或者长度超过20个字节<div class="mtop mdown" > 名称=' + this.s_name +
							'</div>请检查!',
						type: 'success'
					});
					return;

				}
				var temp_data = '';
				temp_data = Method_EasyAdd('data_dep', this.s_name, this.s_note);
				if (this.bak_data == temp_data) {


					this.$message({
						message: '不能重复操作',
						type: 'warning'
					});
					return;
				}
				this.upd_json = temp_data;
				this.bak_data = temp_data;
			},
			fun_del: function() {
				var con = confirm('您确定要删除当前数据!');
				if (con == true) {
					let r = (Math.random() + '').substring(0, 20);
					this.upd_json = Method_EasyDelete('data_dep', this.t_rowid, r);
				}
			},
			fun_upd: function(item) {
				var temp_data = '';
				temp_data = Method_EasyUpdate('data_department', this.t_rowid, this.s_name, this.s_note)
				if (this.bak_data == temp_data) {
					this.$message({
						message: '不能重复操作',
						type: 'warning'
					});
					return;
				}
				this.upd_json = temp_data;
				this.bak_data = temp_data;
			},
			data_clear: function() {
				this.t_rowid = '';
				this.s_name = '';
				this.s_flag = '';

				this.sys_date = '';
			},
			sel_row: function(item) {
				this.data_clear();
				this.t_action_name = '修改';
				this.t_action = 'upd';
				console.log(item);

				this.t_rowid = item.id;
				this.s_name = item.val;
				this.s_note = item.note;
				this.s_flag = item.flag

				this.sys_date = item.sys_date;
				this.$refs.file_table.setCurrentRow(item, 'tr');
			},

		}
	};
</script>
<style scoped>
</style>
